import { Theme } from "@mui/material/styles";
import { Box, BoxProps, SxProps } from "@mui/material";

type CirclePointProps = BoxProps;
type CirclePointColors = "primary" | "secondary" | "error" | "warning" | "info" | "success";
type CirclePointSize = "large" | "medium" | "small";

interface Props extends CirclePointProps {
    children: string;
    color?: CirclePointColors;
    size?: CirclePointSize;
    sx?: SxProps<Theme>;
}

const getColor = (color = "warning") => {
    return {
        primary: "primary.main",
        secondary: "secondary.main",
        error: "error.main",
        warning: "warning.main",
        info: "info.main",
        success: "success.main",
    }[color];
};

const getSize = (size = "medium") => {
    return {
        large: 40,
        medium: 32,
        small: 24,
    }[size];
};

const getFontSize = (size = "medium") => {
    return {
        large: 20,
        medium: 16,
        small: 14,
    }[size];
};

export default function CirclePoint({ children, color, size, sx, ...other }: Props) {
    return (
        <Box
            component="span"
            sx={{
                width: getSize(size),
                height: getSize(size),
                backgroundColor: getColor(color),
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontFamily: "h1.fontFamily",
                fontSize: getFontSize(size),
                fontWeight: size === "large" ? "h4.fontWeight" : "h1.fontWeight",
                color: "#fff",
                ...sx,
            }}
            {...other}
        >
            {children}
        </Box>
    );
}
